// Components
import { AddPlaylistButton } from './AddPlaylistButton';
import {
  CloseIcon,
  ExpandIcon,
  ExpandOutIcon,
  LibraryCollapsedIcon,
  LibraryIcon,
} from '../../../Icons';

// Utils
import { memo, useEffect, useRef } from 'react';

// Components
import { Flex, Space } from 'antd';
import { Tooltip } from '../../../Tooltip';

// I18n
import { useTranslation } from 'react-i18next';

// Redux
import { getLibraryCollapsed, getLibraryExpanded, uiActions } from '../../../../store/slices/ui';
import { yourLibraryActions } from '../../../../store/slices/yourLibrary';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

const isMobile = window.innerWidth < 900;

const CloseButton = () => {
  const dispatch = useAppDispatch();

  return (
    <div className='playing-section-close-button'>
      <button
        onClick={() => {
          dispatch(yourLibraryActions.setView({ view: 'LIST' }));
          dispatch(uiActions.collapseLibrary());
        }}
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export const LibraryTitle = memo(() => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['navbar']);
  const collapsed = useAppSelector(getLibraryCollapsed);
  const expanded = useAppSelector(getLibraryExpanded);
  const view = useAppSelector((state) => state.yourLibrary.view);
  const expandedRef = useRef(expanded);

  useEffect(() => {
    const wasExpanded = expandedRef.current;
    expandedRef.current = expanded;

    if (expanded && !wasExpanded && view !== 'GRID') {
      dispatch(yourLibraryActions.setView({ view: 'GRID' }));
    } else if (!expanded && wasExpanded && view !== 'LIST') {
      dispatch(yourLibraryActions.setView({ view: 'LIST' }));
    }
  }, [dispatch, expanded, view]);

  if (collapsed) {
    return (
      <Tooltip placement='right' title={t('Expand your library')}>
        <button
          type='button'
          className='library-toggle-button'
          aria-label={t('Expand your library')}
          onClick={() => dispatch(uiActions.openLibrary())}
        >
          <LibraryCollapsedIcon />
        </button>
      </Tooltip>
    );
  }

  return (
    <Flex align='center' justify='space-between'>
      <Space wrap align='center'>
        <Tooltip placement='top' title={t('Collapse your library')}>
          <button
            type='button'
            onClick={() => {
              dispatch(yourLibraryActions.setView({ view: 'LIST' }));
              dispatch(uiActions.collapseLibrary());
            }}
          >
            <LibraryIcon />
          </button>
        </Tooltip>
        <span className='Navigation-button'>{t('Your Library')}</span>
      </Space>

      {isMobile ? (
        <CloseButton />
      ) : (
        <Space align='center' size={6}>
          {/* Settings gear intentionally hidden; navigation handled via import card / profile menu */}
          <Tooltip placement='bottom' title={t(expanded ? 'Shrink library view' : 'Expand library view')}>
            <button
              type='button'
              className='library-toggle-button'
              aria-label={t(expanded ? 'Shrink library view' : 'Expand library view')}
              onClick={() => {
                if (expanded) {
                  dispatch(yourLibraryActions.setView({ view: 'LIST' }));
                  dispatch(uiActions.shrinkLibrary());
                } else {
                  dispatch(yourLibraryActions.setView({ view: 'GRID' }));
                  dispatch(uiActions.expandLibrary());
                }
              }}
            >
              {expanded ? <ExpandOutIcon /> : <ExpandIcon />}
            </button>
          </Tooltip>
          <AddPlaylistButton />
        </Space>
      )}
    </Flex>
  );
});
